module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spaceView",
    style: (_vm.style)
  }, _vm._l((_vm.preparedDivs), function(div, index) {
    return _c('space-view-item', {
      key: index,
      attrs: {
        "div": div,
        "height": _vm.height
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-624595a6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Files/SpaceView.vue
// module id = 1268
// module chunks = 1